__turbopack_context__.v({
  "buttons-bottom": "RestaurantMainCard-module-sass-module__ZZPTxq__buttons-bottom",
  "card": "RestaurantMainCard-module-sass-module__ZZPTxq__card",
  "content": "RestaurantMainCard-module-sass-module__ZZPTxq__content",
  "dot": "RestaurantMainCard-module-sass-module__ZZPTxq__dot",
  "favorite": "RestaurantMainCard-module-sass-module__ZZPTxq__favorite",
  "favorite-icon": "RestaurantMainCard-module-sass-module__ZZPTxq__favorite-icon",
  "meta": "RestaurantMainCard-module-sass-module__ZZPTxq__meta",
  "promo-badge": "RestaurantMainCard-module-sass-module__ZZPTxq__promo-badge",
  "rating": "RestaurantMainCard-module-sass-module__ZZPTxq__rating",
  "rest-description": "RestaurantMainCard-module-sass-module__ZZPTxq__rest-description",
  "rest-title": "RestaurantMainCard-module-sass-module__ZZPTxq__rest-title",
  "tag": "RestaurantMainCard-module-sass-module__ZZPTxq__tag",
});
